import { render, staticRenderFns } from "./message-abstract-file.vue?vue&type=template&id=fc3b1086&scoped=true"
import script from "./message-abstract-file.vue?vue&type=script&lang=ts"
export * from "./message-abstract-file.vue?vue&type=script&lang=ts"
import style0 from "./message-abstract-file.vue?vue&type=style&index=0&id=fc3b1086&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc3b1086",
  null
  
)

export default component.exports